import React, { useContext, useEffect, useState } from "react";
import "./FiltersStyles.css";
import { FilterContext } from "../../context/FilterContext";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchIcon from "@mui/icons-material/Search";
import OutlinedInput from "@mui/material/OutlinedInput";
import dayjs from "dayjs";

const FiltersDashboard = () => {
  const {
    stores,
    ageRanges,
    selectedStore,
    cameras,
    setSelectedStore,
    selectedAgeRanges,
    setSelectedAgeRanges,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    setfiltersObj,
    storeLoaded,
    ageRangesLoaded,
    camerasLoaded,
  } = useContext(FilterContext);

  const [openStore, setOpenStore] = useState(false);
  const [openAges, setOpenAges] = useState(false);
  // const [openStartDate, setOpenStartDate] = useState(false);
  // const [openEndDate, setOpenEndDate] = useState(false);

  const handleStoreChange = (event) => {
    setSelectedStore(event.target.value);
  };

  const handleAgeRangesChange = (event) => {
    const {
      target: { value },
    } = event;
    let selectedValues = typeof value === "string" ? value.split(",") : value;

    if (
      selectedValues.length > 1 &&
      selectedValues[selectedValues.length - 1] !== "Todos"
    ) {
      selectedValues = selectedValues.filter((value) => value !== "Todos");
    } else if (selectedValues.length === 1 && selectedValues[0] !== "Todos") {
      selectedValues = event.target.value;
    } else {
      selectedValues = ["Todos"];
    }

    setSelectedAgeRanges(selectedValues);
  };

  const handleSearchButton = () => {
    if (selectedStore === "") {
      alert("Selecciona una tienda");
      return;
    }
    if (selectedAgeRanges.length === 0) {
      alert("Selecciona al menos una segmentación de edad");
      return;
    }
    const age_rangesId = selectedAgeRanges.map(
      (name) => ageRanges.find((ageRange) => ageRange.range_name === name).id
    );

    const selectedStoreName = stores.find(
      (store) => store.id === selectedStore
    ).name;

    const filtersObj = {
      store_id: selectedStore,
      store_name: selectedStoreName,
      cameras: cameras,
      age_ranges: age_rangesId,
      age_range_name: selectedAgeRanges[0],
      start_date: startDate,
      end_date: endDate,
    };
    setfiltersObj(filtersObj);
  };

  useEffect(() => {
    if (storeLoaded && ageRangesLoaded && camerasLoaded) {
      handleSearchButton();
    }
  }, [storeLoaded, ageRangesLoaded, camerasLoaded]);

  // Estilos para select
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <div className="flex p-4 bg-[#0369A1] rounded-2xl pt-5">
      <div className="flex w-full gap-6">
        <div className="w-full sm:w-1/3 md:w-1/4 lg:w-56">
          <FormControl fullWidth>
            <InputLabel
              style={{
                color: "white",
                position: "absolute",
                top: "-5px",
              }}
            >
              Tienda
            </InputLabel>
            <Select
              className="rounded-2xl bg-[#F5F7F6]"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedStore || ""}
              onChange={handleStoreChange}
              open={openStore}
              onOpen={() => setOpenStore(true)}
              onClose={() => setOpenStore(false)}
            >
              {stores.map((store, index) => (
                <MenuItem value={store.id} key={index}>
                  {store.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="w-full sm:w-1/3 md:w-1/4 lg:w-56">
          <FormControl fullWidth>
            <InputLabel
              style={{
                color:
                  openAges || selectedAgeRanges.length > 0 ? "white" : "black",
                position: "absolute",
                top: "-5px",
              }}
            >
              Edad
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              className="bg-[#F5F7F6] rounded-2xl"
              id="demo-multiple-checkbox"
              multiple
              value={selectedAgeRanges || []}
              onChange={handleAgeRangesChange}
              input={<OutlinedInput label="Edad" />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
              open={openAges}
              onOpen={() => setOpenAges(true)}
              onClose={() => setOpenAges(false)}
            >
              {ageRanges.map((ageRange, index) => (
                <MenuItem value={ageRange.range_name} key={index}>
                  {ageRange.range_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="w-full sm:w-1/3 md:w-1/4 lg:w-56">
          {/* Fecha inicial */}
          <FormControl fullWidth>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <InputLabel
                shrink
                style={{
                  color: "white",
                  position: "absolute",
                  top: "-5px",
                }}
              >
                Fecha inicial
              </InputLabel>
              <DatePicker
                className="bg-[#F5F7F6] rounded-md"
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
                value={dayjs(startDate)}
                maxDate={dayjs(endDate)}
                onChange={(date) => {
                  if (date.isAfter(endDate)) {
                    setEndDate(date);
                  }
                  setStartDate(date);
                }}
              />
            </LocalizationProvider>
          </FormControl>
        </div>
        <div className="w-full sm:w-1/3 md:w-1/4 lg:w-56">
          {/* Fecha final */}
          <FormControl fullWidth>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <InputLabel
                shrink
                style={{
                  color: "white",
                  position: "absolute",
                  top: "-5px",
                }}
              >
                Fecha final
              </InputLabel>
              <DatePicker
                className="bg-[#F5F7F6] rounded-md"
                format="DD/MM/YYYY"
                inputFormat="DD/MM/YYYY"
                value={dayjs(endDate)}
                minDate={dayjs(startDate)}
                maxDate={dayjs()}
                onChange={(date) => {
                  if (date.isBefore(startDate)) {
                    setStartDate(date);
                  }
                  setEndDate(date);
                }}
              />
            </LocalizationProvider>
          </FormControl>
        </div>
        {/* Botón buscar */}
        <div
          className="w-1/8 h-full p-4 bg-[#F5F7F6] rounded-md cursor-pointer transform transition-transform duration-300 hover:scale-105 active:scale-80"
          onClick={handleSearchButton}
        >
          <button className="flex gap-4 space-x-8 text-base font-medium">
            <SearchIcon />
            Buscar
          </button>
        </div>
      </div>
    </div>
  );
};

export default FiltersDashboard;
